package io.horion.auth.presentation.state

import io.horion.auth.api.models.domain.LoginMethod
import io.horion.auth.domain.models.Countries
import io.horion.auth.domain.models.Role

data class AccountUiModel(
    val userUuid: String = "",
    val email: String = "",
    val phone: String = "",
    val role: String = Role.USER.name,
    val canAccessService: Boolean = true,
    val isActive: Boolean = false
)

data class AuthUiState(
    val identifier: String = "",
    var phone: String = "",
    var email: String = "",
    var password: String = "",
    var confirmPassword: String = "",
    var code: String = "",
    var codeLogin: String = "",
    var redirect: String = "",
    var service: String = "AUTH",
    val countryCode: String = Countries.CMR.code,
    var method: LoginMethod = LoginMethod.EMAIL,
    val newsletterChecked: Boolean = false,

    val accounts: List<AccountUiModel> = emptyList(),

    var isAuthenticating: Boolean = false,
    var authErrorMessage: String? = null,
    var authenticationSucceed: Boolean = false,
    var confirmSucceed: Boolean = false,
    var verifySucceed: Boolean = false,
    var resetPasswordSucceed: Boolean = false,
    var loginSucceed: Boolean = false,
    var registerSucceed: Boolean = false,
    var logoutSucceed: Boolean = false,
    var isLoading: Boolean = false,
    var isMobileClient: Boolean = false,

    val identifierError: String? = null,
    val generalError: String? = null,
    val emailError: String? = null,
    val passwordError: String? = null,
    val confirmPasswordError: String? = null,
    val phoneError: String? = null,
    val codeError: String? = null,

    val isOtpSent: Boolean = false,
    val passwordOtpSent: Boolean = false,
    val isSendingPasswordOtp: Boolean = false,
    val otpCooldownSeconds: Int = 0,

    var firstName: String = "",
    var lastName: String = "",
    var address: String = "",
    var avatarUrl: String = "",
    var role: String = Role.USER.name,
    var isVerified: Boolean = false,
    var lastLoginDate: String = "",
    var lastLoginLocation: String = "",
    var twoFactorEnabled: Boolean = false,

    var isEditingProfile: Boolean = false,
    var isSavingProfile: Boolean = false,
    var profileSaveSuccess: Boolean = false,
    var profileSaveError: String? = null,

    var currentPassword: String = "",
    var newPassword: String = "",
    var confirmNewPassword: String = "",
    var isChangingPassword: Boolean = false,
    var passwordChangeSuccess: Boolean = false,
    var passwordChangeError: String? = null,

    val isToggling2FA: Boolean = false,
    val show2FASetupModal: Boolean = false,
    val qrCodeUrl: String? = null,           // L'URL ou le Base64 de l'image QR Code générée par Ktor
    val secretKey: String? = null,           // Clé brute ex: "JBSWY3DPEHPK3PXP"
    val twoFactorBackupCodes: List<String>? = null, // Liste des codes de récupération si validation réussie
    val twoFactorSetupError: String? = null,

    val authMethod: LoginMethod = LoginMethod.EMAIL, // Ou récupéré depuis l'utilisateur connecté
    val isProfileCreated: Boolean = false,
    val userEmail: String? = null,
    val userRole: String = "user",
    val userPhone: String? = null,
    var userFirstName: String = "",
    var userLastName: String = "",
    val is2FAEnabled: Boolean = false,

    val city: String = "Douala",             // Ex: Douala, Yaoundé
    val country: String = "Cameroun",        // Ex: Cameroun
    val countryCodes: String = "cm",          // Ex: cm
    val timezone: String = "Africa/Douala",
    val isLoggedIn: Boolean = true,
    val loginTimestamp: String = ""
)